import React, {useState} from 'react';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@material-ui/core';

import {components} from '@arborian/narrf';
import {useFacilities} from 'ccm/dataSource';
import FacilityTable from 'ccm/components/FacilityTable';

const {dt2} = components;

export default function FacilitySelectDialog({dialogRef}) {
    const [resolve, setResolve] = useState(null);
    const dsFacility = useFacilities({
        prefix: null,
        initialFetchOptions: {
            sort: {field: 'attributes.name'},
            page: {number: 0, size: 5},
        },
    });

    const handleSelect = (ev, row) => {
        if (row) {
            resolve({action: 'select', facility: row.data});
        } else {
            resolve({action: 'select', facility: null});
        }
        setResolve(null);
    };

    const handleCancel = () => {
        resolve({action: 'cancel'});
        setResolve(null);
    };

    dialogRef.current = initialValues => {
        return new Promise((resolve, reject) => {
            setResolve(() => resolve);
        });
    };

    return (
        <Dialog open={!!resolve} onClose={handleCancel}>
            <DialogTitle>Facility Selection</DialogTitle>
            <DialogContent>
                <FacilityTable dataSource={dsFacility}>
                    <dt2.Action
                        name='select'
                        onClick={handleSelect}
                        tooltip='Select this facility'
                        icon='check'
                    />
                    <dt2.Action
                        free // free actions dont' send a row
                        name='deselect'
                        onClick={handleSelect}
                        tooltip='De-select any facility'
                        icon='cancel'
                    />
                </FacilityTable>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}
